import React from 'react';
import MeterReadingForm from './MeterReadingForm';

const UpdateMeterReading = () => {
  return <MeterReadingForm isUpdate={true} />;
};

export default UpdateMeterReading;
